import React, { useState, useEffect } from 'react';
import axios from 'axios';
function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }

export default function MobileMDM({ user }) {
  const [status, setStatus] = useState(null);
  const [platforms, setPlatforms] = useState([]);

  useEffect(()=>{
    axios.get('/api/mdm/status',auth()).then(r=>setStatus(r.data.mdm)).catch(()=>{});
    axios.get('/api/mdm/platforms',auth()).then(r=>setPlatforms(r.data)).catch(()=>{});
  },[]);

  const domain = window.location.origin;
  const STATUS_COLOR = { active:'#16a34a', partial:'#d97706', planned:'#64748b', ready:'#1d4ed8' };

  return (
    <div style={{padding:24}}>
      <div style={{marginBottom:24}}><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Mobile & Multi-Platform MDM</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>iOS, Android, macOS, Windows, Linux — unified endpoint management</p></div>

      {/* Platform matrix */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:14,marginBottom:28}}>
        {platforms.map(p=>{
          const sc = STATUS_COLOR[p.status]||'#64748b';
          const icons = { windows:'🪟', macos:'🍎', linux:'🐧', ios:'📱', android:'🤖', chromeos:'🌐' };
          return (
            <div key={p.platform} style={{background:'#fff',border:`2px solid ${sc}20`,borderRadius:12,padding:18}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                <div style={{display:'flex',gap:10,alignItems:'center'}}>
                  <span style={{fontSize:28}}>{icons[p.platform]||'💻'}</span>
                  <div>
                    <div style={{fontWeight:700,fontSize:15,textTransform:'capitalize'}}>{p.platform}</div>
                    <span style={{background:`${sc}15`,color:sc,borderRadius:4,padding:'1px 7px',fontSize:10,fontWeight:700,textTransform:'uppercase'}}>{p.status}</span>
                  </div>
                </div>
              </div>
              <div style={{display:'flex',gap:4,flexWrap:'wrap',marginBottom:8}}>
                {p.features.map(f=><span key={f} style={{background:'#f1f5f9',borderRadius:4,padding:'2px 6px',fontSize:10,color:'#475569'}}>{f}</span>)}
              </div>
              {p.note&&<div style={{fontSize:11,color:'#94a3b8'}}>{p.note}</div>}
              {p.agentInstall&&<div style={{background:'#0f172a',borderRadius:6,padding:'6px 10px',marginTop:8,fontSize:10,fontFamily:'monospace',color:'#94a3b8',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.agentInstall}</div>}
            </div>
          );
        })}
      </div>

      {/* MDM Protocol status */}
      {status&&(
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:14}}>
          {Object.entries(status).map(([platform,info])=>(
            <div key={platform} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
              <div style={{fontWeight:700,fontSize:15,textTransform:'capitalize',marginBottom:6}}>{platform} MDM Protocol</div>
              <span style={{background:info.status==='active'?'#dcfce7':'#fef3c7',color:info.status==='active'?'#16a34a':'#d97706',borderRadius:4,padding:'2px 8px',fontSize:11,fontWeight:700}}>{info.status.toUpperCase()}</span>
              <div style={{fontSize:12,color:'#64748b',marginTop:8}}>{info.note}</div>
              {info.enrollmentUrl&&<div style={{marginTop:8,fontSize:11,fontFamily:'monospace',color:'#475569',background:'#f8fafc',padding:'6px 8px',borderRadius:5,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{info.enrollmentUrl}</div>}
              {info.agentInstall&&<div style={{marginTop:8}}><div style={{fontSize:11,color:'#64748b',marginBottom:4}}>Install command:</div><code style={{fontSize:10,background:'#0f172a',color:'#e2e8f0',padding:'6px 10px',borderRadius:5,display:'block',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{info.agentInstall}</code></div>}
            </div>
          ))}
        </div>
      )}

      {/* Quick links */}
      <div style={{marginTop:28,background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:16}}>
        <div style={{fontWeight:700,color:'#0369a1',marginBottom:12}}>Enrollment URLs</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,fontSize:12}}>
          {[['Windows (PowerShell)',`irm ${domain}/api/enrollment/install/[token] | iex`],
            ['macOS (Bash)',`curl -fsSL ${domain}/api/mdm/install/macos | sudo bash`],
            ['iOS (mobileconfig)',`${domain}/api/mdm/enroll/macos/[token]`],
            ['Android (JSON config)',`${domain}/api/mdm/enroll/android/[token]`],
          ].map(([l,v])=>(
            <div key={l} style={{background:'#fff',borderRadius:7,padding:'10px 12px',border:'1px solid #e0f2fe'}}>
              <div style={{fontWeight:600,color:'#0369a1',marginBottom:4}}>{l}</div>
              <code style={{fontSize:10,color:'#475569',wordBreak:'break-all'}}>{v}</code>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
